import { Injectable, inject } from "@angular/core";
import { NgbModal, NgbModalOptions, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { FastighetGeometry } from "~app/common/components/map/components/menu/map-fastighet/map-fastighet-models";
import { IMapGeometry } from "~app/common/components/map/map.settings";
import { ConfirmDialogResponse } from "~app/common/models/constants";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { SokLeverantorModalComponent } from "~app/features/virkeskop/leverantorer/sok-leverantor-modal/sok-leverantor-modal.component";
import { KontaktDTO } from "../../../../common/models/kontakter/KontaktDTO";
import { ILeverantor, ISearchVirkesleverantor } from "../models/virkesleverantorModel";
import { RedigeraLeverantorDialogComponent } from "./redigera-leverantor-dialog/redigera-leverantor-dialog.component";

@Injectable({
    providedIn: "root"
})
export class LeverantorDialogService {
    private readonly modalService = inject(NgbModal);

    beforeDismiss() {
        return false;
    }

    open(id = null, guid = null, callBack: (result: KontaktDTO) => void = null) {
        const modalRef = this.openDialog(callBack);
        modalRef.componentInstance.kontaktid = id;
        modalRef.componentInstance.guid = guid;
    }

    openNew(newleverantor: ILeverantor, guid: string, callBack: (result: KontaktDTO) => void = null) {
        const modalRef = this.openDialog(callBack);
        modalRef.componentInstance.newleverantor = newleverantor;
        modalRef.componentInstance.guid = guid;
    }

    openSearch(config: any, callbackVirkesleverantor: (leverantorid: ISearchVirkesleverantor[]) => void, callbackFastighetsimport?: (geometry: FastighetGeometry) => void) {
        if (!this.modalService.hasOpenModals()) {
            const modalRef = this.modalService.open(SokLeverantorModalComponent, {
                keyboard: false,
                backdrop: "static",
                size: "xl"
            });
            modalRef.componentInstance.config  = config;
            modalRef.result.then((response) => {
                if(response === ConfirmDialogResponse.cancel) {
                    return;
                }
                if (this.isFastighetsimport(response)) {
                    callbackFastighetsimport(response);
                } else {
                    callbackVirkesleverantor(response);
                }
            }, (reason) => {
                // cancel
                callbackVirkesleverantor([]);
            });
        }
    }

    private isFastighetsimport(object: any): boolean {
        if (ObjectUtils.isNullOrUndefined(object.geometry)) {
            return false;
        }
        const geometry = (object as FastighetGeometry).geometry as IMapGeometry;
        return geometry.attributes !== undefined;
    }

    private openDialog(callBack: (result: KontaktDTO) => void = null): NgbModalRef {
        const options = {
            keyboard: false,
            backdrop: "static",
            size: "lg"
        } as NgbModalOptions;
        const modalRef = this.modalService.open(RedigeraLeverantorDialogComponent, options);
        if (callBack) {
            modalRef.result
                .catch(() => modalRef.close())
                .then(result => callBack(result));
        } else {
            modalRef.result.then(result => modalRef.close(result));
        }
        return modalRef;
    }
}
